import { ThemeTypings } from '@chakra-ui/react';

export enum Severity {
  LOW,
  CONSIDERATION = 0.5,
  MEDIUM = 1,
  HIGH,
}

export function severityColorScheme(severity: Severity): ThemeTypings['colorSchemes'] {
  switch (severity) {
    case Severity.LOW:
      return 'green';
    case Severity.CONSIDERATION:
      return 'teal';
    case Severity.MEDIUM:
      return 'orange';
    case Severity.HIGH:
      return 'red';
  }
}

export type SeverityTone = 'info' | 'success' | 'warning' | 'critical';

/** Severity on the ComplyKit semantic tone axis (badge-status-tag.md). */
export function severityTone(severity: Severity): SeverityTone {
  switch (severity) {
    case Severity.LOW:
      return 'success';
    case Severity.CONSIDERATION:
      return 'info';
    case Severity.MEDIUM:
      return 'warning';
    case Severity.HIGH:
      return 'critical';
  }
}
